import './eventShowings.html.twig';
import './eventShowings.css';

import { fetch as fetchPolyfill } from 'whatwg-fetch';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import highlightOverlay from '../highlightOverlay';

dayjs.extend(utc);

// TODO: Get fetch working in IE 11
export default function() {
  const el = document.querySelector('.event-showings');
  if (!el) {
    return;
  }
  const eventId = el.getAttribute('data-event');
  const expandInstances = '?$expand=instances';
  const carousel = el.querySelector('.event-showings__carousel');
  const leftArrow = el.querySelector('.event-showings__arrow--left');
  const rightArrow = el.querySelector('.event-showings__arrow--right');
  const padding = 16;

  function handleArrows() {
    if (carousel.scrollWidth === carousel.offsetWidth) {
      rightArrow.classList.remove('event-showings__arrow--right--visible');
      leftArrow.classList.remove('event-showings__arrow--left--visible');
    } else if (carousel.scrollLeft <= padding) {
      leftArrow.classList.remove('event-showings__arrow--left--visible');
      rightArrow.classList.add('event-showings__arrow--right--visible');
    } else if (carousel.scrollLeft + carousel.offsetWidth === carousel.scrollWidth) {
      leftArrow.classList.add('event-showings__arrow--left--visible');
      rightArrow.classList.remove('event-showings__arrow--right--visible');
    } else {
      rightArrow.classList.add('event-showings__arrow--right--visible');
      leftArrow.classList.add('event-showings__arrow--left--visible');
    }
  }

  carousel.addEventListener('scroll', handleArrows);
  window.addEventListener('resize', handleArrows);

  function handleControls() {
    rightArrow.addEventListener('click', () => {
      carousel.scrollLeft = carousel.offsetWidth - 50;
    });
    leftArrow.addEventListener('click', () => {
      carousel.scrollLeft = -carousel.offsetWidth - 50;
    });
  }

  function checkStatus(response) {
    if (response.ok) {
      return Promise.resolve(response);
    }
    return Promise.reject(new Error(response.statusText));
  }

  function fetchData(url) {
    return fetch(url)
      .then(checkStatus)
      .then(res => res.json())
      .catch(error => console.error(error));
  }

  fetchData(`https://shop.lamda.ac.uk/lamda/api/v3/events/${eventId + expandInstances}`).then(data => {
    const instances = [
      ...data.instances
        .reduce((prev, curr) => {
          const d = new Date(curr.start).toDateString();
          if (!prev.has(d)) prev.set(d, []);
          prev.get(d).push(curr);
          return prev;
        }, new Map())
        .entries(),
    ]
      .map(([dateStr, instances]) => {
        const date = new Date(dateStr);
        const day = date.getDate();
        const month = date.toLocaleDateString('en-GB', {
          month: 'short',
        });
        return `
        <div class="event-showings__content">
          <span class="event-showings__date-container">
            <span class="event-showings__day">${day}</span>
            <span class="event-showings__month">${month}</span>
          </span>
          <div class="event-showings__time-container">
            ${instances
              .map(instance =>
                !instance.isOnSale
                  ? `<span class="event-showings__sold-out">Sold out</span>`
                  : `<button class="event-showings__button" data-instance="${
                      instance.id
                    }"><time class="event-showings__time" datetime=${instance.start}>${dayjs
                      .utc(instance.start)
                      .format('h:mm a')}</time></button>`
              )
              .join('')}
          </div>
        </div>
      `;
      })
      .join('');

    carousel.innerHTML = instances;

    carousel.querySelectorAll('button').forEach(btn => {
      btn.addEventListener('click', () => {
        var instanceId = parseInt(btn.dataset.instance);
        var url = '/tickets/choose-seats?id=' + instanceId;
        window.open(url, 'spektrix', 'height=800,width=640');
      });
    });

    handleControls();
    handleArrows();

    /** Handle #book-now links */
    document.querySelectorAll('[href="#book-now"]').forEach(lnk => {
      lnk.addEventListener('click', ev => {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        ev.preventDefault();
        highlightOverlay();

        return false;
      });
    });
  });
}
